export default __webpack_public_path__ + "static/media/lb-pp-v-white.a9e9f543.svg";